import { Icon, IconsEnum } from 'components/Icons';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';
import { setIsInfoOpen, toggleNavMobile } from 'features/sport/sportSlice';
import { useGetLabelByKey, useTranslation } from 'hooks/useLingUI';

import { ItemWithTranslation } from 'types/swagger';
import React from 'react';
import { StatisticType } from 'features/sport/utils/betRadar/statisticTypeEnum';
import styles from './SportManifestazioneHeaderSticky.module.scss';
import { SportResultsAndInfoContent } from '../sportResultsAndInfoContent';
import { selectIsInfoOpen } from 'features/sport/selectors';

export type SportManifestazioneHeaderStickyProps = ItemWithTranslation<{
  gruppo?: string;
  manifestazione?: string;
}> & {
  providerID?: string;
  isPreferito: boolean;
};

export const SportManifestazioneHeaderSticky = ({
  gruppo,
  gruppoTrKey,
  providerID,
  isPreferito,
  manifestazione,
  manifestazioneTrKey,
}: SportManifestazioneHeaderStickyProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const isInfoOpen = useTypedSelector(selectIsInfoOpen);
  const labelChange = useGetLabelByKey('cambia')!;

  return (
    <React.Fragment>
      <div className={styles.container}>
        <button type="button" className={styles.infoContainer} onClick={() => dispatch(toggleNavMobile(true))}>
          <div className={styles.infoWrapper}>
            <span className={styles.gruppo}>{t(gruppoTrKey, gruppo)}</span>
            <p className={styles.manifestazioneWrapper}>
              {isPreferito && (
                <Icon
                  iconId={isPreferito ? IconsEnum.FULL_PIN : IconsEnum.PIN}
                  className={styles.iconPin}
                  color="var(--color-primary)"
                />
              )}
              <span className={styles.manifestazione} suppressHydrationWarning={true}>
                {t(manifestazioneTrKey, manifestazione)}
              </span>
            </p>
          </div>
          <span className={styles.changeSelection}>{labelChange}</span>
        </button>
        {!!providerID && providerID !== '0' && (
          <button type="button" className={styles.statBtn} onClick={() => dispatch(setIsInfoOpen(!isInfoOpen))}>
            <Icon
              iconId={isInfoOpen ? IconsEnum.CLOSE : IconsEnum.STATS}
              className={`${styles.iconStats} ${isInfoOpen ? styles.smaller : ''}`}
              color={isInfoOpen ? 'var(--color-primary)' : 'var(--color-on-bg-primary)'}
            />
          </button>
        )}
      </div>
      {!!providerID && providerID !== '0' && isInfoOpen && (
        <SportResultsAndInfoContent isOpen providerID={+providerID} type={StatisticType.Manifestazione} />
      )}
    </React.Fragment>
  );
};
